module.exports = __webpack_public_path__ + "img/img4.b7c13bda.png";